import { type TWhatsappProductId, WHATSAPP_PRODUCTS } from '../constants';

const WHATSAPP_PRODUCT_SET = new Set<string>(WHATSAPP_PRODUCTS);

export const DEFAULT_WHATSAPP_PRODUCT_ROUTE_ID =
  WHATSAPP_PRODUCTS[0].toLowerCase();

export const isWhatsappProduct = (value: string): value is TWhatsappProductId =>
  WHATSAPP_PRODUCT_SET.has(value);

type TWhatsappProductRouteLoaderArgs = {
  params: {
    product?: string;
  };
};

export const whatsappProductRouteLoader = ({
  params,
}: TWhatsappProductRouteLoaderArgs) => {
  if (!isWhatsappProduct((params.product ?? '').toUpperCase())) {
    throw new Response(null, { status: 404 });
  }

  return null;
};

export const whatsappProductFromPathname = (
  pathname: string,
): TWhatsappProductId | undefined => {
  const segments = pathname.split('/');
  const index = segments.indexOf('whatsapp-templates');
  const candidate =
    index === -1 ? '' : (segments[index + 1] ?? '').toUpperCase();

  return isWhatsappProduct(candidate) ? candidate : undefined;
};
